import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { DatagridConfigurable, List, TextField, BooleanField, TextInput, BooleanInput, } from "react-admin";
import { ListActions } from "../../components/ListActions";
import { Typography } from "@mui/material";
var OMIT_FIELDS = ["id"];
var Filters = [
    _jsx(TextInput, { label: "Slug", source: "slug" }, 0),
    _jsx(TextInput, { label: "ID", source: "id" }, 2),
    _jsx(BooleanInput, { label: "Is Active", source: "is_active" }, 3),
];
export var ListTenant = function (_a) {
    var aside = _a.aside;
    var _b = React.useState(false), openDrawer = _b[0], setOpenDrawer = _b[1];
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h5", children: "Tenants" }), _jsx(List, { actions: _jsx(ListActions, { open: openDrawer, setOpen: setOpenDrawer, withFilter: true }), sx: { flexGrow: 2 }, aside: aside, filters: Filters, children: _jsxs(DatagridConfigurable, { rowClick: "edit", omit: OMIT_FIELDS, children: [_jsx(TextField, { source: "id" }), _jsx(TextField, { source: "slug" }), _jsx(BooleanField, { source: "is_active" })] }) })] }));
};
